// Copyright (c) 2019 Deere & Company

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { getDateFormat, getOnlyValues } from '../../../claims/common';
import { AgGridReact } from 'ag-grid-react';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import PropTypes from 'prop-types';
import { WarningAlertBar } from '../../../shared/components/alert-bar';
import WorklistTableColumnDefinitions from '../../column-defination';
import { connect } from 'react-redux';
import { convertUnixtodate } from '../../../shared/services/common-functions';
import { filterEmpty } from '../../../shared/services/validator';
import { getFactoryByCode } from '../../../app/common/repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';
//import CSVFile from "../../../assets/worklist_data_upload.csv";
// import MultipleEntryPopup from "../../../admin/components/function-code-maintenance/multiple-entry-popup";
import WorklistUploadPopup from "./worklist-upload-popup";
import { downloadSampleReports } from '../../../claims/repositories';

const rowSelection = 'single';

class WorkListResultPanel extends Component {

    state = {

        selectedGridRow: {},
        factory: '',
        productSeriesIds: '',
        productSubSeriesIds: '',
        baseCodeIds: '',
        branchIds: [],
        auditCode: '',
        modelIsOpen: false,
        modelIsClose: false,
        uploadResp:''
    };


    componentWillMount = () => {

        this.props.editedInputs.map( item => {

            switch ( item[0] ) {

            case 'factoryCode': this.getFactoryByCode( item[1] ); break;
            case 'productSeriesIds':
            case 'productSubSeriesIds':
            case 'baseCodeIds':
            case 'branchIds': this.updateState( item[0], getOnlyValues( item[1] ) ); break;
            case 'auditCode': this.getAuditList( item[1] ); break;
            default: break;

            }
            return true;

        } );

    }

    onGridReady = params => {

        this.gridApi = params.api;
        this.props.updateGridAPI( this.gridApi );
        try {

            this.gridApi.context.beanWrappers.tooltipManager
                .beanInstance.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 0;

        } catch ( e ) {}

    };

    onClaimClick = element => {

        const elementName = element.event.target.name;
        if ( elementName ) this.props.onClaimDetails( element.node.rowIndex );

    }

    onModify () {

        this.props.onEditSearch();

    }


    onClear () {

        this.props.onNewSearch();

    }

    onSelectionChanged () {

        const selectedRows = this.gridApi.getSelectedRows();
        let selectedRowsString = '';
        selectedRows.forEach( ( selectedRow, index ) => {

            if ( index !== 0 ) {

                selectedRowsString += ', ';

            }
            selectedRowsString = selectedRow;

        } );
        this.setState( {
            selectedGridRow: selectedRowsString,
        } );

    }

    onBtExport () {

        this.gridApi.exportDataAsCsv( {

            processCellCallback: function convertToDate ( cell ) {

                let cellVal = cell.value;

                if ( cell.column.colDef.valueFormatter ) {

                    cellVal = cellVal ? convertUnixtodate( cellVal ) : '';

                }

                return cellVal;

            },

        } );

    }
    onDownloadReport() {
        const exportColumnDefs = WorklistTableColumnDefinitions.filter((colDef, index) => index === 0 || index === 3 || index === 18 || index === 19 || index === 20);

      
        this.gridApi.exportDataAsCsv({
          columnKeys: exportColumnDefs.map(colDef => colDef.field),
          processCellCallback: function convertToDate(cell) {
            let cellVal = cell.value;
            console.log("cellVal ",cell.column.colDef.headerName);
            if (cell.column.colDef.valueFormatter) {
              cellVal = cellVal ? convertUnixtodate(cellVal) : '';
            }
            return cellVal;
        }
        });
      }

    updateState = ( propertyName, propertyValue ) => {

        this.setState( {
            [propertyName]: propertyValue,
        } );

    }

    getFactoryByCode = factoryCode => {

        if ( factoryCode !== '-1' ) {

            getFactoryByCode( factoryCode ).then( response => {

                this.updateState( 'factory', response.factoryDescription );

            } );

        }

    }


    getAuditList = auditCode => {

        this.props.selectedAuditCode.forEach( audit => {

            if ( auditCode === audit.auditCode ) {

                this.updateState( 'auditCode', audit.auditMessage );
                return false;

            }

        } );


    }

    getSearchedValue = ob => {


        const searchedVal = ob[1];
        const searchedName = ob[0];

        switch ( searchedName ) {

        case 'factoryCode': return this.state.factory;
        case 'buildDate':
        case 'processDate': return `${getDateFormat( searchedVal.from, searchedName )} - ${getDateFormat( searchedVal.to, searchedName )}`;
        case 'branchIds': return this.state.branchIds;
        case 'pins':
        case 'claimNumbers':
        case 'partNumber': return this.searchResultHeader( searchedVal );
        case 'auditCode': return this.state.auditCode;
        case 'productSeriesIds': return this.state.productSeriesIds;
        case 'productSubSeriesIds': return this.state.productSubSeriesIds;
        case 'baseCodeIds': return this.state.baseCodeIds;
        default: return searchedVal.toString();

        }


    }

    searchResultHeader = propertyValue => {

        const arr = filterEmpty( propertyValue );
        if ( arr.length > 4 ) {

            return `${arr.length} selected`;

        }
        return arr.join( ', ' );

    }

    onUploadReport = () => {

        this.setState( {
            modelIsOpen: true,
        } );

    }

    onUploadReportClose = () => {

        this.setState( {
            modelIsOpen: false,
        } );

    };

handleDownloadClick = (fileName) => () => {
                console.log("fileName", fileName);
                
                this.props.increaseCounter();
        
                downloadSampleReports(fileName)
                    .then(response => {
                        response.blob().then( blob => {
        
                            const url = window.URL.createObjectURL( blob );
                            const a = document.createElement( 'a' );
                            a.setAttribute( 'download', fileName+'.csv' );
                            a.href = url;
                            document.body.appendChild( a );
                            a.click();
                            a.parentNode.removeChild( a );
                    
                        } );
                        this.props.decreaseCounter();
                    })
                    .catch(() => {
                        this.props.decreaseCounter();
                    });
            }
    render () {

        const errMessage = 'Limited Results Displayed!!! Please Enter Additional/Narrower Search Criteria to get Full Results.';
        const defaultColDef = { resizable: true };
        const items = ( this.props.editedInputs ).map( item => (
            <div className="header-style">
                <label>
                    {this.props.searchedLabels[item[0]]}
                </label>
                <div className="headerResult-style">
                    <span>
                        {this.getSearchedValue( item )}
                    </span>
                </div>
            </div>
        ) );


        return (
            <div className="worklist-result-page">
                <section>
                    <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                    {this.props.workList.length >= 5000 &&
                     this.state.warningAlertOpen === true && (
                        // eslint-disable-next-line react/jsx-indent
                        <WarningAlertBar
                            alertTitle="Warning"
                            dismissHandler={this.dismissHandler}
                        >
                            {errMessage}
                        </WarningAlertBar>
                    ) }
                    <header>
                        <h2 className="page-header">
                            Worklist Search - {this.props.workList.length} Results
                            <i className="fa fa-refresh result-page-refesh" aria-hidden="true" onClick={this.props.onSubmit} title="Refresh" />
                            <button className="primary-button" onClick={this.onBtExport.bind( this )} type="button"><span> Export to CSV </span></button>
                            <button className="primary-button" onClick={this.onModify.bind( this )} type="button"><span> Edit Search </span></button>
                            <button className="primary-button" onClick={this.onClear.bind( this )} type="button"><span> New Search </span></button>
                        </h2>
                        <h2 className="page-header">
                        

                            <button className="primary-button" onClick={this.onUploadReport.bind( this )} type="button"><span> Refine Worklist </span></button>
                        
                             <button className="primary-button" onClick={this.onDownloadReport.bind( this )} type="button"><span> Download Refine Report </span></button>
                             {/* <a className="worklist-report-analysis" title="Field having values can update only" href={CSVFile}
                               download="worklist_data_upload.csv">Sample Report</a> */}
                               <a
                                    className="worklist-report-analysis"
                                    title="Field having values can update only"
                                    onClick={this.handleDownloadClick('worklist_data_upload')}
                                    >
                                    Download Sample Report
                                </a>
                        </h2>
                        <div className="headerPanel-style">
                            {items}
                        </div>


                    </header>
                    <main>
                        <section className="search-result-panel">
                            <div
                                className="ag-theme-balham ag-theme-popupbg"
                            >
                                <AgGridReact
                                    columnDefs={WorklistTableColumnDefinitions}
                                    rowData={this.props.workList}
                                    onGridReady={this.onGridReady}
                                    defaultColDef={defaultColDef}
                                    rowSelection={rowSelection}
                                    onSelectionChanged={this.onSelectionChanged.bind( this )}
                                    onCellClicked={this.onClaimClick.bind( this )}
                                    selectedGridRow={this.state.selectedGridRow}
                                    popupParent={document.body}
                                    enableCellTextSelection={true}
                                />
                            </div>
                        </section>
                    </main>
                    <WorklistUploadPopup
                        isOpen={this.state.modelIsOpen}
                        onClose={this.onUploadReportClose.bind( this.props )}
                    />
                </section>
            </div>
        );

    }

}


WorkListResultPanel.displayName = 'WorkListResultPanel';
WorkListResultPanel.propTypes = {
    workList: PropTypes.array.isRequired,
    onEditSearch: PropTypes.func.isRequired,
    updateGridAPI: PropTypes.func.isRequired,
    onNewSearch: PropTypes.func.isRequired,
    onClaimDetails: PropTypes.func,
    editedInputs: PropTypes.array.isRequired,
    searchedLabels: PropTypes.object.isRequired,
    getSearchList: PropTypes.func.isRequired,
    selectedAuditCode: PropTypes.object.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( WorkListResultPanel );
